import React from "react";
import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";

class Header extends React.Component {
    render() {
        return (
            <>
                <DesktopNavbar {...this.props} />
                <MobileNavbar {...this.props} />
            </>
        );
    }
}

export default Header;
